// =====================================================================
// PLENARIUM - Comprovante de protocolo (PLENARIUM:COMPROVANTE)
// A4 com duas vias (interessado e camara), linha de corte no meio.
// Imprime por um quadro escondido na propria pagina: nao abre aba nova,
// entao o navegador nao bloqueia. Usa so os dados do proprio protocolo.
// PLENARIUM:COMPROVANTE_VIAS -- descricao justificada; se as duas vias nao couberem
// na mesma folha, cada via vai inteira para a sua propria pagina (nada cortado).
// =====================================================================
import React from 'react';
import { Printer, X, CheckCircle } from 'lucide-react';

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const usuarioSalvo = () => { try { return JSON.parse(localStorage.getItem('usuario') || 'null') || {}; } catch (e) { return {}; } };
const TIPO = { ENTRADA: 'Entrada', SAIDA: 'Saída' };

function quemRecebeu(p) {
  const t = (p.tramitacoes || []).slice().sort((a, b) => new Date(a.criadoEm || 0) - new Date(b.criadoEm || 0));
  return (t[0] && t[0].usuarioNome) || usuarioSalvo().nome || '';
}

function htmlComprovante(p) {
  const u = usuarioSalvo(); const camara = u.camara || {};
  const quando = p.criadoEm ? new Date(p.criadoEm) : new Date();
  const data = quando.toLocaleDateString('pt-BR');
  const hora = quando.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const via = (titulo) => `
  <section class="via">
    <header>
      ${camara.logoUrl ? `<img class="brasao" src="${esc(camara.logoUrl)}" alt="">` : ''}
      <div class="cab"><div class="camara">${esc(camara.nome || 'Câmara Municipal')}</div><div class="doc">Comprovante de Protocolo</div></div>
      <div class="via-nome">${esc(titulo)}</div>
    </header>
    <div class="numero"><span>Protocolo nº</span><b>${esc(p.numero)}</b></div>
    <table>
      <tr><th>Data / hora</th><td>${esc(data)} às ${esc(hora)}</td><th>Tipo</th><td>${esc(TIPO[p.tipo] || p.tipo || '')}</td></tr>
      <tr><th>Remetente</th><td colspan="3">${esc(p.remetente)}</td></tr>
      <tr><th>Assunto</th><td colspan="3"><b>${esc(p.assunto)}</b></td></tr>
      ${p.descricao ? `<tr><th>Descrição</th><td colspan="3" class="desc">${esc(p.descricao)}</td></tr>` : ''}
      <tr><th>Destinatário</th><td>${esc(p.destinatario)}</td><th>Setor</th><td>${esc(p.setor)}</td></tr>
      <tr><th>Recebido por</th><td colspan="3">${esc(quemRecebeu(p))}</td></tr>
    </table>
    <div class="assin">
      <div><span></span>Assinatura de quem protocolou</div>
      <div><span></span>Assinatura / carimbo da Câmara</div>
    </div>
    <footer>Guarde este comprovante. Para consultar o andamento, informe o nº ${esc(p.numero)}. · Cód. ${esc(String(p.id || '').slice(0, 8).toUpperCase())}</footer>
  </section>`;
  return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Protocolo ${esc(p.numero)}</title><style>
    @page { size: A4; margin: 10mm; }
    * { box-sizing: border-box; }
    body { margin: 0; font-family: Arial, Helvetica, sans-serif; color: #0f172a; font-size: 11pt; }
    .folha { height: 277mm; display: flex; flex-direction: column; }
    .via { flex: 1; border: 1.5px solid #0f172a; border-radius: 6px; padding: 7mm 8mm; display: flex; flex-direction: column; }
    .corte { text-align: center; color: #64748b; font-size: 9pt; margin: 4mm 0; border-top: 1px dashed #94a3b8; line-height: 0; }
    .corte span { background: #fff; padding: 0 8px; position: relative; top: -1px; }
    header { display: flex; align-items: center; gap: 10px; border-bottom: 2px solid #0f172a; padding-bottom: 4mm; }
    .brasao { width: 18mm; height: 18mm; object-fit: contain; }
    .cab { flex: 1; } .camara { font-size: 14pt; font-weight: bold; text-transform: uppercase; } .doc { font-size: 10.5pt; color: #334155; margin-top: 1mm; }
    .via-nome { border: 1px solid #0f172a; border-radius: 4px; padding: 2mm 3mm; font-size: 9pt; font-weight: bold; text-transform: uppercase; white-space: nowrap; }
    .numero { margin: 4mm 0 3mm; display: flex; align-items: baseline; gap: 8px; } .numero span { font-size: 10pt; color: #334155; } .numero b { font-size: 20pt; letter-spacing: .5px; }
    table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid #94a3b8; padding: 2mm 2.5mm; vertical-align: top; text-align: left; }
    th { width: 26mm; background: #f1f5f9; font-size: 9pt; text-transform: uppercase; color: #334155; }
    .assin { display: flex; gap: 12mm; margin-top: auto; padding-top: 10mm; } .assin div { flex: 1; text-align: center; font-size: 9pt; color: #334155; } .assin span { display: block; border-top: 1px solid #0f172a; margin-bottom: 1.5mm; }
    footer { margin-top: 4mm; font-size: 8pt; color: #64748b; text-align: center; }
    td.desc { text-align: justify; white-space: pre-wrap; hyphens: auto; } /* PLENARIUM:COMPROVANTE_VIAS */
    .via { break-inside: avoid; page-break-inside: avoid; }
    body.medir .folha, body.separadas .folha { height: auto; display: block; }
    body.medir .via { flex: none; }
    body.separadas .corte { display: none; }
    body.separadas .via { min-height: 277mm; }
    body.separadas .via + .corte + .via { break-before: page; page-break-before: always; }
  </style></head><body><div class="folha">${via('Via do interessado')}<div class="corte"><span>✂ recorte aqui</span></div>${via('Via da Câmara')}</div></body></html>`;
}

export function imprimirComprovante(protocolo) {
  if (!protocolo) return;
  const quadro = document.createElement('iframe');
  quadro.setAttribute('aria-hidden', 'true');
  // PLENARIUM:COMPROVANTE_VIAS -- quadro fora da tela, mas com a largura da folha (para medir as vias)
  Object.assign(quadro.style, { position: 'fixed', left: '-10000px', top: '0', width: '210mm', height: '297mm', border: '0', visibility: 'hidden' });
  document.body.appendChild(quadro);
  const doc = quadro.contentWindow.document;
  doc.open(); doc.write(htmlComprovante(protocolo)); doc.close();
  const imprimir = () => {
    // PLENARIUM:COMPROVANTE_VIAS -- as duas vias cabem na mesma folha? Se nao, uma por pagina.
    try {
      const b = doc.body; b.classList.add('medir');
      const r = doc.createElement('div'); r.style.height = '100mm'; b.appendChild(r); const mm = r.offsetHeight / 100; b.removeChild(r);
      const maior = Math.max(0, ...Array.from(doc.querySelectorAll('.via')).map((v) => v.offsetHeight));
      b.classList.remove('medir');
      if (mm > 0 && maior > (277 - 12) / 2 * mm) b.classList.add('separadas');
    } catch (e) { /* segue */ }
    try { quadro.contentWindow.focus(); quadro.contentWindow.print(); } catch (e) { /* segue */ }
    setTimeout(() => { try { document.body.removeChild(quadro); } catch (e) { /* segue */ } }, 60000);
  };
  const imgs = Array.from(doc.images || []);
  if (!imgs.length) { setTimeout(imprimir, 150); return; }
  let falta = imgs.length; const pronto = () => { falta -= 1; if (falta <= 0) setTimeout(imprimir, 100); };
  imgs.forEach((im) => { if (im.complete) pronto(); else { im.onload = pronto; im.onerror = pronto; } });
  setTimeout(() => { if (falta > 0) { falta = 0; imprimir(); } }, 3000);
}

// Janela "Protocolo registrado" logo depois de salvar.
export function ComprovanteRegistrado({ protocolo, onFechar }) {
  if (!protocolo) return null;
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(15,23,42,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(420px, 100%)', background: '#fff', borderRadius: 18, padding: '26px 22px 20px', textAlign: 'center', boxShadow: '0 24px 50px rgba(15,23,42,.3)' }}>
        <CheckCircle size={54} color="#16a34a" style={{ margin: '0 auto 8px', display: 'block' }} />
        <div style={{ fontWeight: 800, fontSize: '1.15rem', color: '#0f172a' }}>Protocolo registrado</div>
        <div style={{ fontSize: '1.7rem', fontWeight: 900, color: '#1d4ed8', margin: '6px 0 2px' }}>nº {protocolo.numero}</div>
        <div style={{ color: '#64748b', marginBottom: 18 }}>{protocolo.assunto}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" className="btn btn-secondary" style={{ flex: 1 }} onClick={onFechar}><X size={15} /> Fechar</button>
          <button type="button" className="btn btn-primary" style={{ flex: 1.4 }} onClick={() => imprimirComprovante(protocolo)}><Printer size={15} /> Imprimir comprovante</button>
        </div>
      </div>
    </div>
  );
}
